import { render } from "./Welcome.vue?vue&type=template&id=64ec9604&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=ts"
export * from "./Welcome.vue?vue&type=script&lang=ts"

import "./Welcome.vue?vue&type=style&index=0&id=64ec9604&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-64ec9604"

export default script